"use client";

import { Text, TextProps } from "@chakra-ui/react";

interface AppBodyTextProps {
  text: string;
  size: TextProps["size"];
  className: string;
}

export function AppBodyText({ text, size, className }: AppBodyTextProps) {
  return (
    <Text
      size={size}
      className={className}
    >
      {text}
    </Text>
  );
}
